export enum QuestionTypes {
  UNIQUE_RESPONSE = 1,
  MULTIPLE_RESPONSE = 2,
  TEXT = 3,
}